<template>
  <v-row no-gutters align="center" class="h-screen">
    <!-- Imagen de autenticación -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="d-none d-md-flex h-screen bg-primary md:flex-column align-center justify-center"
    >
      <!-- Authentication Image Placeholder -->
      <div class="text-center pa-6">
        <h1 class="font-weight-bold alex-brush-regular">Síguenos en:</h1>
        <v-row align="center" justify="center" class="mt-4">
          <v-col cols="auto">
            <v-tooltip text="Nuestra Web" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-web"
                  @click.prevent="viewModel.goToWeb()"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col cols="auto">
            <v-tooltip text="WhatsApp" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-whatsapp"
                  @click.prevent="viewModel.goToWhatsApp()"
                ></v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <!-- Formulario de login -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="flex justify-center align-items-center h-full pa-6"
    >
      <v-card
        class="mx-auto pa-6 pa-md-12 flex justify-center"
        max-width="500"
        border
        flat
      >
        <div>
          <v-img
            :src="viewModel.logoImage"
            :height="50"
            :width="350"
            cover
            class="h-full w-full mx-auto"
            alt="Logo"
          ></v-img>
          <h4 class="text-h5 font-weight-bold text-center mt-4">
            ¡Bienvenido!
          </h4>
          <h5 class="text-subtitle-1 text-center mt-2 mb-8">
            Inicia sesión en tu cuenta
          </h5>

          <!-- Bind the ref properly -->
          <v-form ref="loginForm">
            <v-row justify="center" align="center">
              <!-- Name Input -->
              <v-col cols="12">
                <v-text-field
                  color="primary"
                  v-model="viewModel.name.value"
                  :rules="viewModel.nameRules"
                  placeholder="Documento de Identidad"
                  prepend-inner-icon="mdi-id-card"
                  variant="outlined"
                  required
                  hide-details="auto"
                  type="text"
                  inputmode="numeric"
                  maxlength="15"
                  @keydown.backspace="viewModel.handleBackPress"
                ></v-text-field>
              </v-col>

              <!-- Password Input -->
              <v-col cols="12">
                <v-text-field
                  color="primary"
                  v-model="viewModel.password.value"
                  :rules="viewModel.passwordRules"
                  :append-inner-icon="
                    viewModel.visible.value ? 'mdi-eye-off' : 'mdi-eye'
                  "
                  :type="viewModel.visible.value ? 'text' : 'password'"
                  placeholder="Ingrese su contraseña"
                  prepend-inner-icon="mdi-lock-outline"
                  variant="outlined"
                  @click:append-inner="
                    viewModel.visible.value = !viewModel.visible.value
                  "
                  required
                  hide-details="auto"
                  @keydown.enter="viewModel.login"
                ></v-text-field>
              </v-col>

              <!-- Switch -->
              <v-col cols="6">
                <v-switch
                  v-model="viewModel.rememberMe.value"
                  color="primary"
                  hide-details="auto"
                >
                  <template #label>
                    <span class="text-subtitle-1">Recordarme</span>
                  </template>
                </v-switch>
              </v-col>

              <!-- Link -->
              <v-col cols="6" class="text-end">
                <router-link
                  class="text-subtitle-1 text-bold text-primary"
                  to="/recovery-password"
                >
                  Recuperar Contraseña
                </router-link>
              </v-col>

              <!-- Login Button -->
              <v-col cols="12">
                <div class="d-flex flex-column">
                  <v-btn
                    class="mt-4 text-none"
                    color="primary"
                    block
                    flat
                    height="56"
                    @click="viewModel.login"
                  >
                    Iniciar Sesión
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" class="pt-8">
                <p class="text-center flex justify-center items-center">
                  <span class="text-subtitle-1">¿No tienes una cuenta?</span>
                  <router-link
                    class="text-subtitle-1 text-primary"
                    to="register"
                  >
                    Registrate
                  </router-link>
                </p>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref } from "vue";
import LoginViewModel from "@/viewmodels/auth/LoginViewModel";

// Create a ref for the form and pass it to the ViewModel
const loginForm = ref(null);

// Pass `loginForm` to the ViewModel
const viewModel = new LoginViewModel(loginForm);
</script>
